import * as apiSearchHistory from '@/api/search-history'
import * as _ from 'lodash'
import store from '@/store'

const getDefaultState = () => {
  const defaults = {
    lists: [],
    complete: false,
    canload: true,
    start: 0,
    per_page: 100,
    count: null,
    currentId: null,
    filterTypes: []
  }

  return defaults
}

const searchHistory = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getCurrentList: (state) => _.find(state.lists, list => list.id === state.currentId)
  },
  mutations: {
    setLists: (state, lists) => {
      state.lists.push(...lists)
    },
    setStart: (state, num) => {
      state.start = num
    },
    deleteCount: (state) => {
      state.count = 0
    },
    setCount: (state, num) => {
      if (num > state.per_page) {
        state.count = state.per_page
      } else {
        state.count = num
      }
    },
    subtractionCount: (state) => {
      state.count--
    },
    setComplete: (state) => {
      state.complete = true
    },
    setCanload: (state, boolean) => {
      state.canload = boolean
    },
    resetLists: (state) => {
      state.lists.splice(0, state.lists.length)
    },
    resetComplete: (state) => {
      state.complete = false
    },
    resetAll: (state) => {
      Object.assign(state, getDefaultState())
    },
    setId: (state, id) => {
      state.currentId = id
    },
    deleteList: (state, index) => {
      state.lists.splice(index, 1)
    },
    setFilterTypes: (state, types) => {
      state.filterTypes = types
    }
  },
  actions: {
    getCount: ({ commit, state }) => {
      // 絞り込み指定があった場合は別の所で数えている
      const params = {
        tags: []
      }
      apiSearchHistory
        .count(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            commit('setCount', data.count)
          }
        })
    },
    getLists: async ({ commit, state, dispatch }) => {
      commit('resetLists')

      const params = {
        start: state.start,
        per_page: state.per_page,
        search_order: 'date', // date(作成日順)
        ascending: 'desc'
      }

      if (state.canload) {
        commit('setCanload', false)
        const res = await apiSearchHistory
          .list(params)
          .then(async(response) => {
            const { data } = response
            if (data.status === 0) {
              let { lists } = data
              let counter = -1

              // 絞り込み指定があった場合
              if (state.filterTypes.length) {
                lists = _.filter(lists, list => _.includes(state.filterTypes, list.type))
                counter = lists.length
              }

              // 初期表示時に全件取得
              await commit('setLists', lists)
              commit('setCanload', true)
              commit('setComplete')

              if (counter >= 0) {
                // 絞り込み時はlistsの長さをセット
                commit('setCount', counter)
              } else {
                // 絞り込み以外はAPIを使って数を取得
                dispatch('getCount')
              }
            } else {
              // status=その他: エラーダイアログを表示
              store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
            }
            return data
          })
        return res
      }
    },
    changeFilterTypes: ({ commit }, types) => {
      commit('setFilterTypes', types) 
    },
    setEditId: async ({ commit }, id) => {
      await commit('setId', id) 
    },
    delete: async ({ commit, state }, params) => {
      await apiSearchHistory
        .remove(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const index = _.findIndex(state.lists, list => list.id === params.id)
            commit('deleteList', index)
            commit('subtractionCount')
          }
        })
    },
    deleteAll: async ({ commit, state }, params) => {
      await apiSearchHistory
        .remove(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            commit('resetLists')
            commit('deleteCount')
            commit('setComplete')
          }
        })
    }
  }
}

export default searchHistory
